module.exports = __webpack_public_path__ + "img/2-1.b3907a5f.svg";